import React from "react";

import { SpaceGroupDetailForDisplay } from "builder/spaceGroup/buildSpaceGroupDetail";

interface StatBoxProps {
  label: string;
  value: string;
  textColor?: string;
}

const StatBox: React.FC<StatBoxProps> = ({ label, value, textColor = "text-black" }) => (
  <div className="flex h-[48px] items-center justify-between gap-2 bg-white px-6">
    <span className="text-xs text-gray">{label}</span>
    <span className={`text-s font-bold leading-[1.5] ${textColor}`}>{value}</span>
  </div>
);

const SpaceUsageNumberNav = ({
  spaceGroupDetailDisplay: {
    availability: { numberOfFree, numberOfOccupied, numberOfTotal },
  },
}: {
  spaceGroupDetailDisplay: SpaceGroupDetailForDisplay;
}) => {
  const statOptions = [
    {
      label: "区画数",
      value: numberOfTotal,
    },
    {
      label: "空車",
      value: numberOfFree,
      textColor: "text-blue",
    },
    {
      label: "満車",
      value: numberOfOccupied,
      textColor: "text-full",
    },
  ];

  return (
    <div className="flex items-center justify-between">
      <h2 className="text-xl">区画・利用状況</h2>
      <div className="flex gap-0.5">
        {statOptions.map((option) => (
          <StatBox key={option.label} label={option.label} value={option.value} textColor={option.textColor} />
        ))}
      </div>
    </div>
  );
};

export default SpaceUsageNumberNav;
